import React from "react";
import { Link } from "react-router-dom";
import { IHomeBannerData } from "../../exports/interfaces";

const HomeBanner = (props: { homeBanner: IHomeBannerData[] }) => {
  // const location = useLocation();

  // const navigate = useNavigate();

  // const handleBannerButtonClick = (
  //   e: React.MouseEvent<HTMLElement>,
  //   pathname: string,
  //   hash: string,
  // ) => {
  //   e.preventDefault();

  //   if (location.pathname === `/${pathname}`) {
  //     document.getElementById(hash)?.scrollIntoView({
  //       behavior: "smooth",
  //     });
  //   } else {
  //     navigate(`/${pathname}#${hash}`);
  //   }
  // };

  return (
    <>
      <section
        className="td_hero td_style_1 td_heading_bg td_center td_bg_filed"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_cmsUrl}/uploads/${props.homeBanner[0]?.image[0]?.media?.name})`,
        }}
      >
        <div className="container td_mt_300">
          <div
            className="td_hero_text wow fadeInRight"
            data-wow-duration="0.9s"
            data-wow-delay="0.35s"
          >
            <h1 className="td_hero_title td_fs_32 td_white_color td_mb_12">
              <span>
                {props?.homeBanner[0]?.title.split(" ").slice(0, 4).join(" ")}
              </span>{" "}
              <br />
              {props?.homeBanner[0]?.title.split(" ").slice(4).join(" ")}
            </h1>
            <p
              className="td_hero_subtitle td_fs_18 td_white_color td_mb_30"
              dangerouslySetInnerHTML={{
                __html: props?.homeBanner[0]?.description,
              }}
            ></p>
            <h1 className="td_hero_title td_fs_16 td_white_color td_mb_12 td_medium font-source-sans">
              <span>{props?.homeBanner[0]?.sub_title}</span>
            </h1>
            <Link
              to="/application-form"
              className="td_btn td_style_1 td_radius_10 td_medium"
            >
              <span className="td_btn_in td_white_color td_orange_bg">
                <span>Apply Now</span>
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.1575 4.34302L3.84375 15.6567"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.157 11.4142C15.157 11.4142 16.0887 5.2748 15.157 4.34311C14.2253 3.41142 8.08594 4.34314 8.08594 4.34314"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </Link>
          </div>
        </div>
        <div className="td_lines">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </section>

      {/* <div className="container">
        <div className="td_hero_btn_group"> */}
      {/* <Link
            to="/about"
            className="td_btn td_style_1 td_radius_10 td_medium td_fs_20 wow fadeInUp"
            data-wow-duration="0.9s"
            data-wow-delay="0.35s"
          >
            <span className="td_btn_in td_white_color td_accent_bg">
              <span>Who We Are</span>
            </span>
          </Link> */}
      {/* <Link
            to="/community-university#how-you-can-help"
            className="td_btn td_style_1 td_radius_10 td_medium td_fs_20 wow fadeInUp"
            data-wow-duration="0.9s"
            data-wow-delay="0.35s"
            onClick={(e) =>
              handleBannerButtonClick(
                e,
                "community-university",
                "how-you-can-help",
              )
            }
          >
            <span className="td_btn_in td_white_color td_accent_bg">
              <span>Get Involved</span>
            </span>
          </Link> */}
      {/* <Link
            to="/employee-application-form"
            className="td_btn td_style_1 td_radius_10 td_medium td_fs_20 wow fadeInUp custom-apply-button"
            data-wow-duration="0.9s"
            data-wow-delay="0.35s"
            onClick={(e) => e.preventDefault()}
            style={{ cursor: "not-allowed" }}
            // target="_blank"
            // rel="noopener noreferrer"
          >
            <span className="td_btn_in td_white_color td_orange_bg">
              <span>Apply Now</span>
            </span>
          </Link> */}
      {/* </div>
      </div> */}
    </>
  );
};

export default HomeBanner;
